import * as React from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import CardItem from '../resource/components/card_item'
import {Arrows} from './Arrows'

type Resource = {
  featured?: boolean
  id: number
  title: string
  resource_type: string
  resource_id?: number
  url?: string
  cover_image_data: string | null
  cover_image_url?: string | null
  length_estimate: string
  category_list: string | null
  resource_category_id: number
  body?: string
}

type Props = {
  resources: Array<Resource>
  isFacilitator?: boolean
  isLearner?: boolean
  heading: string
  viewAllText: string
  viewAllUrl: string
  emptyStateText: string
}

type State = {
  initialSettings: Record<string, any>
}

class FeaturedResourceSlider extends React.Component<Props, State> {
  private sliderRef: React.RefObject<Slider>

  constructor(props: Props) {
    super(props)

    this.sliderRef = React.createRef()

    this.state = {
      initialSettings: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3, 
        slidesToScroll: 3,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      }
    }
  }

  getCoverImageUrl(coverImageData: string | null): string | null {
    if (!coverImageData || coverImageData === 'null') return null
    
    try {
      const imageData = JSON.parse(coverImageData)
      return imageData.id || null
    } catch {
      return null
    }
  }

  truncateText(text: string | undefined, maxLength: number = 150): string {
    if (!text || text === 'null') return ''
    
    const trimmed = text.trim()
    
    if (trimmed.length <= maxLength) {
      return trimmed
    }
    
    return trimmed.slice(0, maxLength) + '...'
  }

  handleDelete = (id: number) => {
  }

  render() {
    const { resources, isFacilitator, isLearner, heading, viewAllText, viewAllUrl, emptyStateText } = this.props
    const items = resources || []
    
    return (
      <div>
        <div className="resource-heading-container">
          <h2 className="slider-section-heading">
            {heading}
          </h2>
          {items.length > 0 && <Arrows sliderRef={this.sliderRef} />}
        </div>

        <div className="">
          {items && items.length > 0 ? (
            <div className="featured-resource-slider">
              <Slider ref={this.sliderRef} {...this.state.initialSettings}>
                {items.map((resource, index) => {
                  return (
                    <div key={resource.id} className="slider-card-wrapper">
                      <CardItem
                        resource={resource}
                        isAdmin={false}
                        resourceCategoryId={resource.resource_category_id}
                        index={index}
                        handleDelete={() => {}}
                        showCategory={true}
                        cardBackground="primary"
                      />
                    </div>
                  )
                })}
              </Slider>
            </div>
          ) : (
            <div className="empty-state text-center">
              {emptyStateText}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default FeaturedResourceSlider